import React from "react";

// Compteur d'une section (commentaires, tâches, documents) : plein quand il y a
// quelque chose, discret à zéro.
const Compteur = ({ children, plein }) => (
  <span className={`la-compteur ${plein ? "la-compteur--plein" : ""}`.trim()}>{children}</span>
);

export default Compteur;
